import axios from 'axios';
import qs from 'qs';
import { readCookie } from '@/tools/tools';

axios.defaults.withCredentials = true;
const service: any = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // 设置超时
  timeout: 20000
});
// 请求拦截
service.interceptors.request.use(
  (response: any) => {
    const config = response;
    if (readCookie('accessToken')) {
      config.headers.common.accessToken = readCookie('accessToken');
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);
// 响应拦截
service.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error.response) {
      switch (error.response.status) {
        // 本地的请求url
        case 403:
          window.location.href = '/login';
          break;
        case 401:
          window.location.href = '/login';
          break;
        case 502:
          window.location.href = '/login';
          break;
        default:
      }
    }
  }
);

// get请求
export default {
  get(url: string = '', params: any = {}, method = 'get') {
    return new Promise((resolve, reject) => {
      service({
        url,
        method,
        params
      })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  // post请求
  post(url: string = '', params: any = {}, headers?: any) {
    return new Promise((resolve, reject) => {
      service({
        url,
        data: headers.fileType ? params : qs.stringify(params),
        method: 'post',
        headers
      })
        .then((res: any) => {
          resolve(res);
        })
        .then((err: any) => {
          reject(err);
        });
    });
  }
};
